import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type EjnToogle = {
  sendToProtestVisible: boolean;
  sendNotificationVisible: boolean;
  selectedTab: string;
};

const initialState: EjnToogle = {
  sendToProtestVisible: false,
  sendNotificationVisible: false,
  selectedTab: 'PENDING_DECISION',
};

const extrajudicialNotificationsToogleSlice = createSlice({
  name: 'extrajudicialNotificationsFilters',
  initialState,
  reducers: {
    reset: () => initialState,
    showSendNotification: (state) => ({
      ...state,
      sendNotificationVisible: true,
      sendToProtestVisible: false,
    }),
    showSendToProtest: (state) => ({
      ...state,
      sendNotificationVisible: false,
      sendToProtestVisible: true,
    }),
    hideSendNotification: (state) => ({
      ...state,
      sendNotificationVisible: false,
    }),
    hideSendToProtest: (state) => ({
      ...state,
      sendToProtestVisible: false,
    }),
    setTab: (state, tab: PayloadAction<string>) => ({
      ...state,
      selectedTab: tab.payload,
    }),
  },
});

export const {
  reset,
  showSendNotification,
  showSendToProtest,
  hideSendNotification,
  hideSendToProtest,
  setTab,
} = extrajudicialNotificationsToogleSlice.actions;

export default extrajudicialNotificationsToogleSlice.reducer;
